import useApi from 'common/hooks/useApi';
import React, { useEffect } from 'react';
import DevSandboxPresenter from './DevSandboxPresenter';

function DevSandboxContainer() {
  const [intermediaryCodes, getIntermediaryCodes] = useApi({
    url: '/codeTables/dwellingTypes',
    method: 'GET',
  });

  useEffect(() => {
    getIntermediaryCodes();
  }, [getIntermediaryCodes]);

  // Put all data logic here...
  return (
    <div className='container'>
      <DevSandboxPresenter intermediaryRes={intermediaryCodes} />
    </div>
  );
}

export default DevSandboxContainer;
